<div class="quote-card p-3">
  <div class="quote-card-inner">

    <!-- LEFT: Clinic info -->
    <div class="clinic-main">

      <div class="clinic-thumb" (click)="navigateToDetail()">
        <img class="clinic-img"
          (error)="coverImg.src = 'assets/dentalclinic.webp'"
          #coverImg
          [src]="partner?.coverUrl ?? 'assets/dentalclinic.webp'" />
      </div>

      <div class="clinic-meta">
        <div class="meta-header">
          <span class="clinic-name fw-semibold text-break" (click)="navigateToDetail()">{{ partner?.name }}</span>
          <div *ngIf="hasReviews" class="clinic-rating" (click)="openReviewsOffcanvas($event)">
            <app-rating-badge [averageRate]="partner?.averageRate"
              [small]="screenSize.isMobile"></app-rating-badge>
            <span class="reviews-count">({{ reviewsLabel | translate }})</span>
          </div>
        </div>

        <div class="meta-location small text-muted">
          <i class="ti ti-map-pin"></i>
          <span>{{ partner?.city }}, {{ partner?.region | placeName }}, {{ partner?.country }}</span>
        </div>

        <div class="meta-langs">
          <i class="ti ti-world"></i>
          <img *ngFor="let flag of flagsSrcs"
            [src]="flag.src" [alt]="flag.name | translate"
            [title]="flag.name | translate" [attr.aria-label]="flag.name | translate" />
        </div>
      </div>
    </div>

    <!-- Vertical divider (desktop only) -->
    <div class="v-divider" *ngIf="!quote?.pdfPreview"></div>

    <!-- RIGHT: Quote panel -->
    <div class="quote-panel">

      <!-- MOBILE: services left, price right -->
      <div class="panel-top-mobile d-md-none">
        <app-clinic-inclusions [quote]="quote" class="inclusions-flex"></app-clinic-inclusions>
        <div *ngIf="!hideAmount" class="price-box">
          <span class="price-label">{{ 'Estimated price' | translate }}</span>
          <span class="price-value">{{ AmountUtils.formatAmount(quote?.declaredAmount, 'EUR') }}</span>
        </div>
      </div>

      <!-- DESKTOP: price + services stacked, right-aligned -->
      <div class="panel-top-desktop d-none d-md-flex">
        <div *ngIf="!hideAmount" class="price-box">
          <span class="price-label">{{ 'Estimated price' | translate }}</span>
          <span class="price-value">{{ AmountUtils.formatAmount(quote?.declaredAmount, 'EUR') }}</span>
        </div>
        <app-clinic-inclusions [quote]="quote"></app-clinic-inclusions>
      </div>

      <!-- Action buttons -->
      <div class="action-btns mt-1">
        <ng-container *ngIf="quote?.canReview">
          <app-button label="{{ 'Leave a review' | translate }}" (onClick)="navigateToReview()"
            [icon]="'star'" [size]="'sm'"></app-button>
        </ng-container>
        <ng-container *ngIf="requestStatus==undefined">
          <app-button label="{{ 'Contact' | translate }}" (onClick)="navigateToRequest()"
            [icon]="'mail'" [size]="'sm'"></app-button>
        </ng-container>
        <ng-container *ngIf="quote?.pdfPreview">
          <app-button label="{{ 'View Quote' | translate }}" (onClick)="viewPdf()"
            [icon]="'file-type-pdf'" [size]="'sm'"></app-button>
        </ng-container>
        <ng-container *ngIf="requestStatus==RequestStatus.PENDING && !quoteRequested">
          <app-button label="{{ 'Request quote details' | translate }}" (onClick)="sendQuoteRequestDetails()"
            [icon]="'file-type-pdf'" [size]="'sm'"></app-button>
        </ng-container>
        <!-- Quando la recensione è possibile, "Leave a review" sostituisce il pulsante disabilitato. -->
        <ng-container *ngIf="requestStatus==RequestStatus.PENDING && quoteRequested && !quote?.pdfPreview && !quote?.canReview">
          <app-button label="{{ 'Quote requested' | translate }}" [isDisabled]="true"
            [icon]="'circle-check'" [size]="'sm'"></app-button>
        </ng-container>
      </div>

    </div>
  </div>
</div>

<app-confirmation-modal #confirmationModal></app-confirmation-modal>
